import React from 'react';
import PropTypes from 'prop-types';
import { AspectRatioContainer } from 'components';

export class RoundShadowButton extends React.PureComponent {
	static propTypes = {
		icon: PropTypes.string,
		totalWidthClass: PropTypes.string,
		cicleWidthClass: PropTypes.string,
		imageWidthClass: PropTypes.string,
		textClassName: PropTypes.string,
		text: PropTypes.string,
		removeTextComponent: PropTypes.bool,
		removeShadow: PropTypes.bool,
		disabled: PropTypes.bool,
		hoverBackground: PropTypes.bool,
		onClick: PropTypes.func,
		innerRef: PropTypes.func
	}

	static defaultProps = {
		icon: null,
		totalWidthClass: '',
		cicleWidthClass: 'w-6',
		imageWidthClass: 'w-3',
		text: '',
		removeTextComponent: false,
		removeShadow: false,
		onClick: PropTypes.func,
		disabled: false,
		hoverBackground: false
	}

	render() {
		const {
			icon,
			cicleWidthClass,
			imageWidthClass,
			totalWidthClass,
			textClassName,
			text,
			removeTextComponent,
			onClick,
			removeShadow,
			disabled,
			hoverBackground,
			innerRef
		} = this.props;

		return (
			<button
				ref={innerRef}
				type="button"
				disabled={disabled}
				className={`flex flex-col items-center focus:outline-none ${totalWidthClass} ${disabled &&
					'pointer-events-none'}`}
				onClick={onClick}>
				<AspectRatioContainer widthClassName={`${cicleWidthClass}`}>
					<div
						className={`rounded-full transition bg-white ${hoverBackground ? 'hover:bg-gray-350' : ''} ${
							removeShadow ? '' : 'shadow-lg hover:shadow-button'
						} flex justify-center items-center absolute w-full h-full ${disabled &&
							'bg-gray-550'}`}>
						<img
							className={`${imageWidthClass}`}
							src={icon}
							alt="button" />
					</div>
				</AspectRatioContainer>
				{!removeTextComponent && (
					<p
						className={`text-xs h-4 mt-1 ${textClassName} ${disabled &&
							'text-gray-550'}`}>
						{text}
					</p>
				)}
			</button>
		);
	}
}
